var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    on: {
      "click": _vm.toggle
    }
  }, [_vm.$root.theme === 'night' ? _c('img', {
    attrs: {
      "src": require("@/assets/theme_toggle/day.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("@/assets/theme_toggle/night.svg")
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }